// uses window by infra2 standards whenever is set
var rootEnv = window['LUCID_SPA_CONFIG'] || process.env;
export var REACT_APP_LAS_API_URL = rootEnv.REACT_APP_LAS_API_URL || '';
export var REACT_APP_AMS_API_URL = rootEnv.REACT_APP_AMS_API_URL || '';
export var REACT_APP_AUTH0_DOMAIN = rootEnv.REACT_APP_AUTH0_DOMAIN || '';
export var REACT_APP_AUTH0_CLIENT_ID = rootEnv.REACT_APP_AUTH0_CLIENT_ID || '';
export var REACT_APP_AUTH0_CALLBACK = rootEnv.REACT_APP_AUTH0_CALLBACK || '';
export var REACT_APP_APP_VERSION = rootEnv.REACT_APP_APP_VERSION || '';
export var REACT_APP_PKG_NAME = rootEnv.REACT_APP_PKG_NAME || '';
//# sourceMappingURL=env.js.map